import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PARTNER360_FIN_SOB_NAMESPACE } from './constants'
import { initialState } from './сonfigs'

const finSobSlice = createSlice({
  name: PARTNER360_FIN_SOB_NAMESPACE,
  initialState,
  reducers: {
    changeFinSobApplicableSwitcherLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isApplicableSwitcherLoading = payload
    },

    changeFinSobIsPlanningSettingsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isPlanningSettingsLoading = payload
    },

    changeFinSobIsPartnerFlagsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isPartnerFlagsLoading = payload
    },

    changeFinSobIsPlanningDataLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isPlanningDataLoading = payload
    },

    changeFinSobIsPlanningFactorsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isPlanningFactorsLoading = payload
    },
    changeFinSobIsCategoryPlanningApplyingChangesLoading: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isCategoryPlanningApplyingChangesLoading = payload
    },

    changeFinSobIsCategoryPlanningDataLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isCategoryPlanningDataLoading = payload
    },
  },
})

export const {
  changeFinSobApplicableSwitcherLoading,
  changeFinSobIsPlanningDataLoading,
  changeFinSobIsPlanningFactorsLoading,
  changeFinSobIsPartnerFlagsLoading,
  changeFinSobIsPlanningSettingsLoading,
  changeFinSobIsCategoryPlanningDataLoading,
  changeFinSobIsCategoryPlanningApplyingChangesLoading,
} = finSobSlice.actions

export default finSobSlice.reducer
